module.exports = __webpack_public_path__ + "static/media/data.1d23af98.svg";